module.exports = __webpack_public_path__ + "img/icons_UI_icon_check_mint.ba5399a9.svg";